import * as Constants from './constants'

const initialState = {
  addQuestionLoading: false,
  getQuestionLoading: false,
  ownerLoading: false,
}

const reducer = function questionReducer (state = initialState, action) {
  // console.log('reducer add assessment ====>', action)
  switch (action.type) {
    case Constants.ADD_REQUEST:
      return {
        addQuestionLoading: true,
        messages: [{
          body: 'Adding Question...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.ADD_SUCCESS:
      return {
        addQuestion: action.result.meta,
        addQuestionLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.ADD_ERROR:
      return {
        addQuestionLoading: false,
        addQuestion: {
          code: 400,
          message: (action.error && action.error.message) || String(action.error || 'Save failed'),
        },
        messages: [],
        errors: (state.errors || []).concat([{
          body: (action.error && action.error.message) || String(action.error || 'Save failed'),
          time: new Date(),
        }]),
      }

    case Constants.GET_REQUEST:
      return {
        getQuestionLoading: true,
        messages: [{
          body: 'Getting Question...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.GET_SUCCESS:
      return {
        getQuestion: action.result,
        getQuestionLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.GET_ERROR:
      return {
        getQuestionLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.ADD_CLEAR:
      return {
        addQuestionLoading: false,
        messages: [],
        errors: [],
      }

    case Constants.OWNER_REQUEST:
      return {
        ownerLoading: true,
        messages: [{
          body: 'Getting Owners...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.OWNER_SUCCESS:
      return {
        owners: action.result,
        ownerLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.OWNER_ERROR:
      return {
        ownerLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    default:
      return state
  }
}

export default reducer
